import React from 'react';
import { Handle } from 'reactflow';

export default function TeamNode({ data }) {
  return (
    <div style={{
      border: '1px solid #ddd',
      borderRadius: '16px',
      padding: '16px 12px 12px',
      backgroundColor: '#ffffff',
      boxShadow: '0 4px 10px rgba(0, 0, 0, 0.06)',
      width: '180px',
      position: 'relative',
      fontFamily: 'sans-serif',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center'
    }}>

      <img
        src={data.avatarUrl || '/assets/images/AvatarDefault.png'}
        alt={data.name}
        style={{ width: '48px', height: '48px', borderRadius: '50%', objectFit: 'cover', marginBottom: '8px' }}
      />

      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: '4px', position: 'relative', width: '100%' }}>
        <h4 style={{ fontSize: '14px', fontWeight: '600', color: '#333', margin: '0 auto' }}>{data.name}</h4>
        
      </div>

      <p style={{ fontSize: '12px', color: '#888', margin: 0 }}>{data.role}</p>

      <Handle type="target" position="top" style={{ background: '#bbb' }} />
      <Handle type="source" position="bottom" style={{ background: '#bbb' }} />
    </div>
  );
}
